import React from 'react';
import {ConfigApi, MenuProductViewType, OrderType} from "../../../../services/Api/types";
import {DateHelper} from "../../../../services/Common/Date/DateHelper";
import {useTranslation} from "react-i18next";
import ItemAvailabilityHelper from "../../../../services/Menu/services/Item/ItemAvailabilityHelper";

interface Props {
    forceNotAvailable?: true;
    isAvailable: boolean;
    item: Record<string, any>;
    locale: string | undefined;
    availability: any;
    viewType: MenuProductViewType;
    orderType: OrderType;
    pickupDate: string | undefined;
    config: ConfigApi | undefined;
    menus: any[];
    category: any;
    availabilities: any[];
}

const MenuCategoryProductAvailabilityInfo = ({
                                                 forceNotAvailable,
                                                 isAvailable,
                                                 item,
                                                 locale,
                                                 availability,
                                                 viewType,
                                                 orderType,
                                                 pickupDate,
                                                 config,
                                                 menus,
                                                 category,
                                                 availabilities
                                             }: Props) => {
    const {t} = useTranslation();
    
    const drawAvailability = () => {
        if (forceNotAvailable) return <></>;

        if (isAvailable) return <></>;

        const availabilityInfos = ItemAvailabilityHelper.getItemAvailabilityInfo(item, availability, config, menus, availabilities, category, pickupDate, orderType, locale, t);
        const infos: string[] = ItemAvailabilityHelper.getParsedAvailabilityInfos(availabilityInfos);

        if (viewType === MenuProductViewType.HORIZONTAL) return (
            <span className="badge badge-warning text-warning fw-normal" style={{
                whiteSpace: 'pre-wrap',
            }}>
                <span className="badge-warning-text">
                    {infos.join(".\n")}
                </span>
            </span>
        )

        return (
            <p className="card-text text-warning fw-normal product-availability-info">
                {infos.join(". ")}
            </p>
        )
    };

    return drawAvailability();
}

export default MenuCategoryProductAvailabilityInfo;